import { useQuery } from '@tanstack/react-query';
import { clientFetch } from '~/lib/.client/fetch';
import { projectStore } from '~/lib/stores/project';
import { invariant } from '~/utils/invariant';

const getLogs = async ({
  projectId,
  iso_timestamp_start,
  iso_timestamp_end,
  sql,
}: {
  projectId?: string;
  iso_timestamp_start: string;
  iso_timestamp_end: string;
  sql: string;
}) => {
  invariant(projectId);
  const params = new URLSearchParams({
    sql,
    iso_timestamp_start,
    iso_timestamp_end,
  }).toString();

  const response = await clientFetch(`/api/supabase/logs/${projectId}?${params}`);

  const parsedResponse = await response.json<{ error?: { message: string }; result: unknown[] }>();

  if (parsedResponse.error) {
    throw new Error(parsedResponse.error.message);
  }

  return parsedResponse;
};

export const useGetLogs = (
  params: {
    iso_timestamp_start?: string;
    iso_timestamp_end?: string;
    sql?: string;
  } = {},
) => {
  const projectId = projectStore.projectId.get();
  const queryKey = ['logs', projectId, params.sql];

  return useQuery({
    queryKey,
    queryFn: () => {
      const now = new Date();
      const oneHourAgo = new Date(now.getTime() - 60 * 60 * 1000);

      const queryParams = {
        sql: params.sql ?? '',
        iso_timestamp_start: params.iso_timestamp_start ?? oneHourAgo.toISOString(),
        iso_timestamp_end: params.iso_timestamp_end ?? now.toISOString(),
      };

      return getLogs({ projectId, ...queryParams });
    },
    enabled: !!projectId,
    retry: false,
  });
};
